module.exports = __webpack_public_path__ + "static/media/error.a302467e.png";